<template>
  <v-layout row justify-center>
    <CModal :show.sync="dialog" :title="dialogTitle" max-width="500px" scrollable>
        <v-progress-linear v-if="processing" :style="{ margin: 0 }" :indeterminate="true"></v-progress-linear>
        <v-container fill-height fluid :class="$style['card-container']">
          <v-layout nowrap>
            <v-flex>
              <v-card outlined :class="$style['card-content']">
                <v-card-text :class="$style['card-text']">
                  <form>
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="{
                        required: 'required'
                      }"
                      name="一括編集CSV"
                      vid="file"
                      ref="v-file"
                    >
                      <input
                              v-if="file && file.fileName"
                              v-model="file.fileName"
                              type="hidden"
                              ref="hidden"
                      />
                      <v-file-input
                              v-if="showInput"
                              class="file-field"
                              filled
                              :error-messages="mergedErrorMessages(errors[0])"
                              name="一括編集CSV"
                              :loading="uploading"
                              @change="onFileChanged"
                              :placeholder="file ? file['fileName'] : ''"
                              @click:clear="onRemove"
                              :accept="accept"
                      />
                    </ValidationProvider>
                  </form>
                  <template v-if="resourceName === 'import_recipes'">
                    <div style="padding-bottom: 15px;">
                    下記手順に沿って、レシピ一括登録を実施してください。
                    </div>
                    <div style="padding-bottom: 15px;">
                    ①CSVファイルの入力<br>
                    ■ファイルの入力：マニュアルを基に各項目を入力してください。<br>
                    ■ファイル名：『import_recipes.csv』　<br>
                    ※ファイル名は固定のため、必ず上記名称を使用してください。
                    </div>
                    <div style="padding-bottom: 15px;">
                    ②画像ファイルの選定<br>
                    ■画像サイズ： 630 x 350 px<br>
                    ■画像ファイル名：半角英数字<br>
                    ※画像ファイル名は、CSVファイルの「画像ファイル名」に一致する必要があります。
                    </div>
                    <div style="padding-bottom: 15px;">
                    ③画像フォルダの作成<br>
                    ■画像フォルダ名：『images』　<br>
                    ※フォルダ名は固定のため、必ず上記名称を使用してください。
                    </div>
                    <div style="padding-bottom: 15px;">
                    ④画像ファイルの格納<br>
                    ②の画像ファイルを③で作成した『images』フォルダにすべて格納してください。
                    </div>
                    <div style="padding-bottom: 15px;">
                    ⑤新規でフォルダを作成<br>
                    ■フォルダ名：半角英数字で命名し、スペース(半角、全角)を含まないでください。<br>
                    ■フォルダへの格納物：①CSVファイルと③imagesフォルダ
                    </div>
                    <div style="padding-bottom: 15px;">
                    ⑥フォルダの圧縮<br>
                    ⑤で作成したフォルダをZIP形式(パスワードなし)に圧縮。<br>
                    </div>
                    <div style="padding-bottom: 15px;">
                    ⑦レシピ一括登録<br>
                    ⑥で圧縮したフォルダを『レシピ一括登録』より送信してください。
                    </div>
                  </template>
                  <template v-if="resourceName === 'import_products'">
                    <div style="padding-bottom: 15px;">
                    下記手順に沿って、商品一括登録を実施してください。
                    </div>
                    <div style="padding-bottom: 15px;">
                    ①CSVファイルの入力<br>
                    ■ファイルの入力：マニュアルを基に各項目を入力してください。<br>
                    ■ファイル名：『import_products.csv』　<br>
                    ※ファイル名は固定のため、必ず上記名称を使用してください。
                    </div>
                    <div style="padding-bottom: 15px;">
                    ②画像ファイルの選定<br>
                    ■画像サイズ： 630 x 350 px<br>
                    ■画像ファイル名：半角英数字<br>
                    ※画像ファイル名は、CSVファイルの「画像ファイル名」に一致する必要があります。
                    </div>
                    <div style="padding-bottom: 15px;">
                    ③画像フォルダの作成<br>
                    ■画像フォルダ名：『images』　<br>
                    ※フォルダ名は固定のため、必ず上記名称を使用してください。
                    </div>
                    <div style="padding-bottom: 15px;">
                    ④画像ファイルの格納<br>
                    ②の画像ファイルを③で作成した『images』フォルダにすべて格納してください。
                    </div>
                    <div style="padding-bottom: 15px;">
                    ⑤新規でフォルダを作成<br>
                    ■フォルダ名：半角英数字で命名し、スペース(半角、全角)を含まないでください。<br>
                    ■フォルダへの格納物：①CSVファイルと③imagesフォルダ
                    </div>
                    <div style="padding-bottom: 15px;">
                    ⑥フォルダの圧縮<br>
                    ⑤で作成したフォルダをZIP形式(パスワードなし)に圧縮。<br>
                    </div>
                    <div style="padding-bottom: 15px;">
                    ⑦商品一括登録<br>
                    ⑥で圧縮したフォルダを『商品一括登録』より送信してください。
                    </div>
                  </template>
                  <template v-if="resourceName === 'import_masters'">
                    <div style="padding-bottom: 15px;">
                    下記手順に沿って、マスタ一括登録を実施してください。
                    </div>
                    <div style="padding-bottom: 15px;">
                    ①CSVファイルの入力<br>
                    ■ファイルの入力：マニュアルを基に各項目を入力してください。<br>
                    </div>
                    <div style="padding-bottom: 15px;">
                    ②マスタ一括登録<br>
                    ①で作成したCSVを『一括登録csvインポート』より送信してください。
                    </div>
                    <div v-html="resultMessage"></div>
                  </template>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
          <template #footer>
            <v-btn :class="$style['reset-dialog-btn']" color="primary" @click.native="submit" v-if="showSubmit">送信</v-btn>
          </template>
    </CModal>
  </v-layout>
</template>

<script>
  import axios from "@/axios";
export default {
  props: {
    resourceName: {
      type: String // import_recipes,import_products,import_masters
    },
    accept: {
      type: String,
      default: ".zip"
    }
  },
  data() {
    return {
      showInput: true,
      uploading: false,
      showSubmit: true,
      resultMessage: ''
    };
  },
  watch: {
    dialog(show) {
      const vm = this;
      if (!show) {

        const csvProvidor = vm.$refs["v-file"];
        csvProvidor.reset();

        if (this.resourceName === 'import_masters') {
          this.$emit('close-csv-import-dialog');
          this.resultMessage = '';
          // フィールドをリセットするために一度破棄する
          this.showInput = false
          this.$nextTick(function () {
            this.showInput = true
          });
        }

      } else {
        this.showSubmit = true;
      }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.$store.getters[this.resourceName + "/csv/open"];
      },
      set(value) {
        this.$store.commit(this.resourceName + "/csv/close");
      }
    },
    file: {
      get() {
        return this.$store.getters[this.resourceName + "/csv/file"];
      },
      set(value) {
        this.$store.commit(this.resourceName + "/csv/updateFile", {
          file: value
        });
      }
    },
    processing() {
      return this.$store.getters[this.resourceName + "/csv/processing"];
    },
    dialogTitle() {
      switch (this.resourceName) {
        case 'import_recipes':
          return "レシピ一括編集CSV読込";
        case 'import_products':
          return "商品一括編集CSV読込";
        case 'import_masters':
          return "一括登録csvインポート";
        default:
          return "";
      }
    },
    errorMessages() {
      return this.$store.getters[this.resourceName + `/csv/errorMessages`] || {};
    },
    mergedErrorMessages() {
      return vvErr => {
        const messages = [];
        const errorMessages = (this.errorMessages || {}).file || (this.errorMessages || {}).fileName || [];
        if (vvErr) {
          messages.push(vvErr);
        }
        if (errorMessages.length) {
          errorMessages.forEach(v => messages.push(v));
        }
        return messages;
      };
    },
    mergedConfirmErrorMessages() {
      return vvErr => {
        const messages = [];
        if (vvErr) {
          messages.push(vvErr);
        }
        return messages;
      };
    }
  },
  methods: {
    async submit() {
      const csvProvidor = this.$refs["v-file"];
      const csvResult = await csvProvidor.validate();

      if (csvResult.valid) {

        this.$store
          .dispatch(this.resourceName + "/csv/import", {})
          .then((response) => {
            if (this.resourceName !== 'import_masters') {
              this.$message({
                message: "読込が完了しました。",
                type: "success"
              });
              this.$store.commit(`${this.resourceName}/csv/close`);
              this.$router.push({ path: `/${this.resourceName}` });
            } else {
              this.resultMessage = response.data.message;
              if (response.data.success) {
                this.showSubmit = false;
              }
            }
          });
      }
    },
    onFileChanged(file) {
      if (file) {
        this.uploading = true;
        let formData = new FormData();
        formData.append("file", file);

        this.$store
          .dispatch(this.resourceName + "/csv/upload", {formData, zip: this.resourceName !== 'import_masters'})
          .then(() => {
            this.uploading = false;
          }).catch(() => {
          this.uploading = false;
        });
      }
    },
    onRemove() {
      this.file = {
        fileName: "",
        hashName: ""
      };
    }
  },
  mounted() {
  }
};
</script>

<style module lang="scss">
.card-container {
  padding: 0px !important;
}
.card-text {
  padding: 0px !important;
}
.card-content {
  overflow-y: auto;
  padding: 8px 0 !important;
  border: none !important;
}
.error-messages {
  margin: 0;
  margin-top: 8px !important;
  padding-left: 46px !important;
  & > li {
    list-style-type: none;
    min-height: 23px;
    line-height: 12px;
    font-size: 12px;
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
  }
}
.reset-dialog-btn {
  & > span {
    font-size: 14px !important;
  }
}
</style>
<style lang="scss">
.v-card__title {
  font-size: 14px !important;
}

.v-messages {
  margin-top: 5px;
}

.modal-body {
  padding-bottom: 0;
}
</style>
